import $ from 'jquery';

// Elements with the ALL selector will automatically have toasts attached.
const ALL = '[data-toggle="toast"]';

// For full API reference, see the Bootstrap docs:
// https://getbootstrap.com/docs/4.3/components/toasts/#usage
const initToast = (element, options) => $(element).toast(options)
const DELAY = 5000;
const REMOVE_TIMEOUT = DELAY + 1000;
let toastsContainer;

// Override toasts delay
$.fn.toast.Constructor.Default.delay = DELAY;

const createToastsContainer = () => {
  const toaster = document.createElement("div");
  toaster.classList.add('toasts-container');
  toaster.setAttribute('aria-live', 'polite');
  toaster.setAttribute('aria-atomic', 'true');
  document.body.appendChild(toaster);
  return toaster;
}

// Generate a toast based on arguments
const toast = (message, style = "") => {
  const template = `
    <div class="toast ${style}" data-toggle="toast" role="alert" aria-live="assertive" aria-atomic="true">
      <div class="toast-header">
        <span class="mr-auto">${message}</span>
        <button type="button" class="close" data-dismiss="toast" aria-label="Close"></button>
      </div>
    </div>
  `;

  const toast = document.createElement("div");
  toast.innerHTML = template;

  toastsContainer.appendChild(toast);
}

export default {
  // Expose a simple function for selecting all toasts currently present in the DOM,
  // and for binding a MutationObserver that adds toasts to new elements.
  attachAll: (options) => {
    toastsContainer = document.getElementById("toasts-container") || createToastsContainer();
    initToast(ALL, options);

    // This shows all toasts present in the DOM on page render
    document.querySelectorAll(ALL).forEach((toast) => {
      $(toast).toast('show');
      setTimeout(() => toast.remove(), REMOVE_TIMEOUT);
    })

    // This will check if new toasts have been added to the DOM
    // and then will show and then hide the toasts with animations
    const observer = new MutationObserver((mutations) => {
      mutations.filter((m) => m.addedNodes.length > 0).forEach((mutation) => {
        const elements = $(mutation.target).find('[data-toggle="toast"]');
        initToast(elements, options);
        elements.toast('show');
        setTimeout(() => elements.remove(), REMOVE_TIMEOUT);
      })
    })

    observer.observe(document.body, { childList: true, subtree: true })
  },

  notice: (message) => {
    toast(message);
  },

  error: (message) => {
    toast(message, "toast-danger");
  }
}
